import { type FC, useState } from 'react';

import CheckmarkCircle from '@crehana/compass.icons.fill/CheckmarkCircle';
import {
  cn,
  Popper,
  PopperContent,
  PopperTrigger,
} from '@crehana/compass.ui/v2';

import type { TValidationProps } from '../../types';
import { colorBackground, iconColor } from '../../utils';
import PopperError from '../PopperError';

const Validation: FC<React.PropsWithChildren<TValidationProps>> = ({
  label,
  state,
  popper,
  buttonLabel,
  handleError,
}) => {
  const textColor = 'dark:tw-text-neutral-light-100 tw-text-neutral-light-800';

  const [showPopper, setShowPopper] = useState<boolean>(false);

  const isEmpty = state === undefined;
  const isSuccess = state;

  const handleClick = () => {
    if (handleError) {
      handleError();
      return;
    }
    setShowPopper(prev => !prev);
  };

  return (
    <div
      className={cn(
        'tw-border tw-border-solid tw-flex tw-items-center tw-justify-between tw-p-1.6 tw-rounded-1 tw-w-full',
        colorBackground(isEmpty, !!isSuccess),
      )}
    >
      <div className="tw-flex tw-items-center">
        <CheckmarkCircle
          size={16}
          className={iconColor(isEmpty, !!isSuccess)}
        />
        <p className={`tw-font-body4 tw-ml-0.8 ${textColor}`}>{label}</p>
      </div>
      {state === false && (
        <>
          {popper && (
            <Popper open={showPopper}>
              <PopperTrigger
                className="tw-font-subtitle6 tw-text-alert-500"
                type="button"
                onClick={handleClick}
              >
                {buttonLabel}
              </PopperTrigger>
              <PopperContent
                align={'start'}
                side={'right'}
                removePadding
                onBlurCapture={() => setShowPopper(false)}
              >
                <PopperError
                  {...popper}
                  onDismiss={() => setShowPopper(false)}
                />
              </PopperContent>
            </Popper>
          )}
        </>
      )}
    </div>
  );
};

export default Validation;
